(() => {
  const root = document.documentElement;
  const native = root.dataset.wannNativeLanguage || root.lang;
  const published = (root.dataset.wannPublishedLanguages || native).split('|').filter(Boolean);
  const supported = language => language === 'tr' || language === 'en';
  const fallback = !published.includes('tr') || !published.includes('en');
  let saved;
  try { saved = localStorage.getItem('wann-language'); } catch {}
  let language = fallback ? (supported(saved) ? saved : root.dataset.wannDefaultLanguage || 'tr') : native;
  const dictionary = window.WannTranslations;
  if (!dictionary) return;
  const initialText = new WeakMap();
  const initialAttributes = new WeakMap();
  const apply = selected => {
    language = selected;
    root.lang = selected;
    const strings = dictionary[selected];
    document.querySelectorAll('[data-wann-i18n]').forEach(element => {
      const key = element.dataset.wannI18n;
      if (!Object.hasOwn(strings, key)) return;
      if (!initialText.has(element)) initialText.set(element, element.innerHTML);
      let text = strings[key];
      if (element.hasAttribute('data-wann-i18n-index')) text = text.split('|')[Number(element.dataset.wannI18nIndex)] || '';
      if (element.hasAttribute('data-wann-i18n-hero')) {
        const parts = text.split('*');
        text = parts[0] + (parts[1] ? '<em>' + parts[1] + '</em>' : '') + (parts[2] || '');
      }
      element.innerHTML = selected === native ? initialText.get(element) : text;
    });
    document.querySelectorAll('*').forEach(element => {
      for (const attribute of Array.from(element.attributes)) {
        if (!attribute.name.startsWith('data-wann-i18n-') || ['data-wann-i18n-hero', 'data-wann-i18n-index', 'data-wann-i18n-attribute-index'].includes(attribute.name)) continue;
        const name = attribute.name.slice('data-wann-i18n-'.length);
        if (!Object.hasOwn(strings, attribute.value)) continue;
        let originals = initialAttributes.get(element);
        if (!originals) { originals = {}; initialAttributes.set(element, originals); }
        if (!Object.hasOwn(originals, name)) originals[name] = element.getAttribute(name);
        const translated = element.hasAttribute('data-wann-i18n-attribute-index') ? strings[attribute.value].split('|')[Number(element.dataset.wannI18nAttributeIndex)] : strings[attribute.value];
        element.setAttribute(name, selected === native ? originals[name] : translated);
      }
    });
    document.querySelectorAll('#WannLanguageForm button[name="language_code"]').forEach(button => button.setAttribute('aria-pressed', String(button.value === selected)));
    const pageTitle = document.querySelector('.wann-lp__title');
    if (pageTitle) document.title = pageTitle.textContent.trim() + ' — What a NICE Night';
    document.dispatchEvent(new CustomEvent('wann:languagechange', {detail:{language:selected}}));
  };
  const form = document.getElementById('WannLanguageForm');
  if (form) form.addEventListener('submit', event => {
    const selected = event.submitter?.value;
    if (!supported(selected)) return;
    try { localStorage.setItem('wann-language', selected); } catch {}
    if (fallback) { event.preventDefault(); apply(selected); return; }
    let destination = form.querySelector('input[name="return_to"]');
    if (!destination) { destination = document.createElement('input'); destination.type = 'hidden'; destination.name = 'return_to'; form.appendChild(destination); }
    destination.value = window.location.pathname + window.location.search + window.location.hash;
  });
  if (fallback && supported(language)) apply(language);
  root.dataset.wannLocaleReady = 'true';
})();
